import { jsx as X } from "react/jsx-runtime";
import { createContext as Y, useState as e, useRef as d, useCallback as n, useEffect as Z } from "react";
import { resolveImageUrl as $ } from "./utils/imageProxy.js";
import { DEFAULT_THEME as tt, applyThemeCssVars as et } from "./utils/theme.js";
import { loadThemeFonts as S, applyThemeConfigColors as C } from "./utils/fontLoader.js";
import { extractWasAuthenticated as ot } from "./utils/authSnapshot.js";
const st = Y(null);
function mt({ adapter: o, children: g }) {
  const [r, i] = e("native"), [a, v] = e(""), [P, k] = e(tt), [x, T] = e({
    token: null,
    status: "unknown"
  }), [A, u] = e(null), [I, l] = e(null), [E, U] = e(!1), [y, B] = e({ brandAppConfig: null, domainConfig: null }), [M, O] = e(""), [_, m] = e({}), [D, c] = e(null), [H, R] = e([]), [W, b] = e(""), [w, F] = e(!1), [j, f] = e(!1), [L, h] = e([]), s = d(o);
  s.current = o;
  const p = d("native"), V = n(
    (t) => {
      s.current.saveState(t);
    },
    []
  ), q = n(
    (t) => {
      s.current.sendCommand(t);
    },
    []
  );
  Z(() => (o.onInit((t) => {
    p.current = t.env, i(t.env), v(t.apiBaseUrl), k(t.theme), T(t.auth), u(t.savedState), l(t.themeConfig), U(t.editMode), B(t.ctx), O(t.urlSearchParams ?? ""), et(t.theme), S(t.themeConfig), C(t.themeConfig);
  }), o.onData((t) => {
    m(t.toolInput), c(t.toolOutput), F(ot(t.toolOutput, p.current)), R(t.dataParts ?? []), b(t.partState ?? ""), t.savedState && u(t.savedState);
  }), o.onStreamStart((t) => {
    m(t), f(!0), h([]);
  }), o.onStreamChunk((t, N) => {
    h((Q) => [...Q, t]), c(N);
  }), o.onStreamEnd((t) => {
    c(t), f(!1);
  }), o.onThemeConfig((t) => {
    l(t), S(t), C(t);
  }), o.connect(), () => {
    o.destroy();
  }), [o]);
  const z = n(
    (t) => $(t, a, r),
    [a, r]
  ), G = n(
    (t) => {
      s.current.emitAction({ action: "product_click", payload: t });
    },
    []
  ), J = n(
    (t) => {
      s.current.emitAction({ action: "product_suggested", payload: t });
    },
    []
  ), K = {
    env: r,
    theme: P,
    auth: x,
    apiBaseUrl: a,
    ctx: y,
    urlSearchParams: M,
    resolveImageUrl: z,
    trackProductClick: G,
    trackProductSuggested: J,
    toolInput: _,
    toolOutput: D,
    dataParts: H,
    partState: W,
    sendCommand: q,
    savedState: A,
    saveState: V,
    wasAuthenticated: w,
    isStreaming: j,
    streamChunks: L,
    themeConfig: I,
    editMode: E,
    _adapter: s.current
  };
  return /* @__PURE__ */ X(st.Provider, { value: K, children: g });
}
export {
  mt as BridgeHostProvider,
  st as WidgetHostCtx
};
